import produce from 'immer'

import {
  CONTENT_TYPE_CHANGED,
  BRAND_CHANGED,
  INTERVAL_CHANGED,
  FIELD_CHANGED,
  FETCH_BRANDS_AGGREGATES,
  FETCH_BRANDS_AGGREGATES_SUCCESS,
  FETCH_BRANDS_AGGREGATES_FAILURE,
  FETCH_CONTENT_TYPES_AGGREGATES,
  FETCH_CONTENT_TYPES_AGGREGATES_SUCCESS,
  FETCH_CONTENT_TYPES_AGGREGATES_FAILURE,
  FETCH_DOCUMENTS_AGGREGATES,
  FETCH_DOCUMENTS_AGGREGATES_SUCCESS,
  FETCH_DOCUMENTS_AGGREGATES_FAILURE,
} from '../actions/types'

export const initialState = {
  contentType: '',
  brand: '',
  interval: 'year',
  field: 'lastUpdatedDate',

  brandsAggregates: [],
  brandsAggregatesFetching: false,
  brandsAggregatesFetched: false,
  brandsAggregatesError: null,

  contentTypesAggregates: [],
  contentTypesAggregatesFetching: false,
  contentTypesAggregatesFetched: false,
  contentTypesAggregatesError: null,

  documentsAggregates: [],
  documentsAggregatesFetching: false,
  documentsAggregatesFetched: false,
  documentsAggregatesError: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case CONTENT_TYPE_CHANGED: {
      draft.contentType = payload
      break
    }
    case BRAND_CHANGED: {
      draft.brand = payload
      break
    }
    case INTERVAL_CHANGED: {
      draft.interval = payload
      break
    }
    case FIELD_CHANGED: {
      draft.field = payload
      break
    }
    case FETCH_BRANDS_AGGREGATES: {
      draft.brandsAggregatesFetching = true
      break
    }
    case FETCH_CONTENT_TYPES_AGGREGATES: {
      draft.contentTypesAggregatesFetching = true
      break
    }
    case FETCH_DOCUMENTS_AGGREGATES: {
      draft.documentsAggregatesFetching = true
      break
    }
    case FETCH_BRANDS_AGGREGATES_SUCCESS: {
      draft.brandsAggregates = payload
      draft.brandsAggregatesFetching = false
      draft.brandsAggregatesFetched = true
      draft.brandsAggregatesError = null
      break
    }
    case FETCH_CONTENT_TYPES_AGGREGATES_SUCCESS: {
      draft.contentTypesAggregates = payload
      draft.contentTypesAggregatesFetching = false
      draft.contentTypesAggregatesFetched = true
      draft.contentTypesAggregatesError = null
      break
    }
    case FETCH_DOCUMENTS_AGGREGATES_SUCCESS: {
      draft.documentsAggregates = payload
      draft.documentsAggregatesFetching = false
      draft.documentsAggregatesFetched = true
      draft.documentsAggregatesError = null
      break
    }
    case FETCH_BRANDS_AGGREGATES_FAILURE: {
      draft.brandsAggregatesFetching = false
      draft.brandsAggregatesFetched = true
      draft.brandsAggregatesError = payload
      break
    }
    case FETCH_CONTENT_TYPES_AGGREGATES_FAILURE: {
      draft.contentTypesAggregatesFetching = false
      draft.contentTypesAggregatesFetched = true
      draft.contentTypesAggregatesError = payload
      break
    }
    case FETCH_DOCUMENTS_AGGREGATES_FAILURE: {
      draft.documentsAggregatesFetching = false
      draft.documentsAggregatesFetched = true
      draft.documentsAggregatesError = payload
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
